/** @format */
import { MarketCode } from '@mpb-com/feather/enums';

import {
    marketsWithModernSlaveryStatement,
    marketsWithPlatformTermsOfUse,
    marketsWithTotalsExcludingTax,
} from '@toucan/client/global/market';

export const hasTotalsExcludingTax = (market: MarketCode) =>
    marketsWithTotalsExcludingTax.includes(market);

export const hasModernSlaveryStatement = (market: MarketCode) =>
    marketsWithModernSlaveryStatement.includes(market);

export const hasPlatformTermsOfUse = (market: MarketCode): boolean =>
    marketsWithPlatformTermsOfUse.includes(market);
